import React, {Component} from 'react'
import ReactHighcharts from 'react-highcharts/ReactHighcharts'

/** REDUX **/
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import * as nodeChartsActions from '../../actions/nodeCharts'

const initializeChart = (time, series) => {
    let times = new Set;

    return time.forEach((data, index) => {
        return [new Date(data).getTime(), series[index]];
    });
};


class SemiCircle extends Component {

    constructor(props) {

        super(props);
    }

    handleChart() {
        let state = {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: 0,
                plotShadow: false,
                height: 200,
                backgroundColor: '#FAFAFA'
            },
            title: {
                text: '',
                align: 'center',
                verticalAlign: 'middle',
                y: 40
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            plotOptions: {
                pie: {
                    size: 200,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false
                    },
                    startAngle: -90,
                    endAngle: 90,
                    center: ['50%', '75%']
                }
            },
            series: [{
                type: 'pie',
                name: 'Stations Status',
                innerSize: '50%',
                data: this.props.data,
                dataRefreshRate: 10
            }],
            /*            colors: ['#4cb944', '#eca400', '#f03a47'], */
            colors: ['#6abb5e', '#e69620', '#cf776c'],
            credits: {
                enabled: false
            }
        };

        return (
            <ReactHighcharts ref={r => {
                this.semiCircle = r;
            }} className={'semiCircle'} config={state}/>
        );
    }

    componentDidMount() {
        if (this.semiCircle.chart.series[0]) {
            this.semiCircle.chart.series[0].data[0].setState('hover')
            this.semiCircle.chart.tooltip.refresh(this.semiCircle.chart.series[0].data[0]);
        }
    }

    render() {
        return (
            <div className={this.props.className}>
                {this.handleChart()}
            </div>
        )
    }
}


const
    chartStateToProps = (state) => {
        return {}
    };

const
    chartDispatchToProps = (dispatch) => {
        return {}
    };

export default connect(chartStateToProps, chartDispatchToProps)

(
    SemiCircle
)



// WEBPACK FOOTER //
// ./src/components/HighCharts/SemiCircle.js